<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form :inline="true" label-suffix=":" :label-position="`left`" :size="size" @submit.native.prevent>
        <el-row>
          <el-col :md="16">
            <el-form-item :label="$t('분류')">
              <el-radio-group v-model="searchForm.dateSearchTp">
                <el-radio-button :label="$t('시간별')"></el-radio-button>
              </el-radio-group>

              <div class="area-date">
                <template v-if="'HOUR' == searchForm.dateSearchTpVal">
                  <el-date-picker
                    v-model="searchForm.seDt"
                    type="daterange"
                    unlink-panels
                    style="width: 260px"
                    :clearable="false"
                    :editable="false"
                    value-format="yyyy-MM-dd"></el-date-picker>
                </template>
              </div>

              <combo
                :data="timeList"
                :model="searchForm.startTime"
                @change="searchForm.startTime = $event"
                style="width: 130px"></combo>
              ~
              <combo
                :data="timeList"
                :model="searchForm.endTime"
                @change="searchForm.endTime = $event"
                style="width: 130px"></combo>
            </el-form-item>
          </el-col>
          <!--				<el-form-item :label="$t('시작 시간')">-->
          <!--				</el-form-item>-->
          <!--				<el-form-item :label="$t('끝 시간')">-->
          <!--				</el-form-item>-->
          <el-form-item :label="$t('유형')">
            <el-radio-group v-model="searchForm.timeTp">
              <el-radio-button :label="$t('결제수단')"></el-radio-button>
              <el-radio-button :label="$t('주문유형')"></el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('StatisticsMenuSearch')"
        :size="size"
        @click="search"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <!--			<el-button v-if="checkAuthActionAccess('StatisticsMenuSearch')" :size="size"  @click="chart" icon="el-icon-picture-outline" >{{ $t('그래프 보기') }}</el-button>-->
      <SalesBasisInfo basis="net" class="basis-inline" />
    </div>

    <!-- 리스트 -->
    <el-table
      v-if="'orderTp' == searchForm.timeTpVal"
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')">
      <el-table-column
        :label="$t('시간')"
        prop="date"
        min-width="60"
        align="center"
        label-class-name="data_cnt"></el-table-column>
      <el-table-column
        :label="$t('포스 주문')"
        prop="pos"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('키오스크 주문')"
        prop="kiosk"
        min-width="120"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('테이블 주문')"
        prop="table"
        min-width="130"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('전화 주문')"
        prop="telephone"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('배달앱 주문')"
        prop="deliveryApp"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('파트너 주문')"
        prop="partner"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('모바일 테이블 주문')"
        prop="mobileTable"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('기타')"
        prop="etc"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('합계')"
        prop="sum"
        min-width="100"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
    </el-table>

    <el-table
      v-if="'salesTp' == searchForm.timeTpVal"
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')">
      <el-table-column
        :label="$t('시간')"
        prop="date"
        min-width="60"
        align="center"
        label-class-name="data_cnt"></el-table-column>
      <el-table-column
        :label="$t('현금')"
        prop="cash"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('카드')"
        prop="card"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('포인트')"
        prop="point"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('간편결제')"
        prop="easy"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('온라인결제')"
        prop="online"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('기타')"
        prop="etc"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
      <el-table-column
        :label="$t('합계')"
        prop="sum"
        sortable
        align="right"
        :formatter="mainVue.formatterNum"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { statisticsAxisRange } from '@/utils/periodFilter'
import SalesBasisInfo from '@/components/SalesBasisInfo.vue'

export default {
  mixins: [mainVueMixin],
  components: { SalesBasisInfo },

  data: function () {
    var data = initData()
    data.url = '/statistics/time'
    data.searchForm = this.initSearchForm()

    // data.dialogChartVisible = false;
    data.timeList = this.initTimeList()

    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    // 분류 선택 이벤트 — 고른 축의 기본 기간은 `utils/periodFilter` 의 `statisticsAxisRange` 한 곳이 셈한다(KST 달력)
    'searchForm.dateSearchTp': function (newVal) {
      if (this.$t('시간별') == newVal) {
        this.searchForm.dateSearchTpVal = 'HOUR'
      } else if (this.$t('일별') == newVal) {
        this.searchForm.dateSearchTpVal = 'DAY'
      } else if (this.$t('월별') == newVal) {
        this.searchForm.dateSearchTpVal = 'MONTH'
      } else if (this.$t('년별') == newVal) {
        this.searchForm.dateSearchTpVal = 'YEAR'
      }
      Object.assign(this.searchForm, statisticsAxisRange(this.searchForm.dateSearchTpVal, Date.now()))
      this.search()
    },

    // 분류 선택 이벤트
    'searchForm.timeTp': function (newVal) {
      if (this.$t('결제수단') == newVal) {
        this.searchForm.timeTpVal = 'salesTp'
      } else if (this.$t('주문유형') == newVal) {
        this.searchForm.timeTpVal = 'orderTp'
      }

      this.search()
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        dateSearchTp: this.$t('시간별'),
        // dateSearchTpVal: 't',
        dateSearchTpVal: 'HOUR',
        // seDt: [util.getDate('yyyy-MM-dd HH:mm', util.dateAdd('HOUR ', -2, new Date())), util.getNow('yyyy-MM-dd HH:mm')], // 시간별
        // seDt: [util.getDate('yyyy-MM-dd', util.dateAdd('w ', -1, new Date())), util.getNow('yyyy-MM-dd')], // 일별
        seDt: [util.getNow('yyyy-MM-dd'), util.getNow('yyyy-MM-dd')], // 일별 + 시간
        startDt: '',
        endDt: '',
        timeTp: this.$t('결제수단'),
        timeTpVal: 'salesTp',
        startTime: '00',
        endTime: '23',
      }
    },
    initTimeList: function () {
      const timeList = []

      for (let i = 0; i < 24; i++) {
        let singleDigitCorrection = ''
        if (i < 10) {
          singleDigitCorrection = '0'
        }

        const test = this.dateFormatter(i)
        timeList.push({ label: test, value: singleDigitCorrection + i })
      }
      return timeList
    },
    // 조회
    search: function () {
      var startDateTime = ''
      var endDateTime = ''
      // 년 일때는 설정 안해줌
      if ('HOUR' == this.searchForm.dateSearchTpVal) {
        if (null == this.searchForm.seDt || this.searchForm.seDt.length < 2) {
          this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })
          return
        }
        this.searchForm.startDt = this.searchForm.seDt[0]
        this.searchForm.endDt = this.searchForm.seDt[1]
        startDateTime = this.searchForm.startDt + ' ' + this.searchForm.startTime + ':00:00'
        endDateTime = this.searchForm.endDt + ' ' + this.searchForm.endTime + ':59:59'
      }

      var param = {
        startDateTime: startDateTime,
        endDateTime: endDateTime,
        type: this.searchForm.timeTpVal,
      }

      this.mainVue.$axios.search(
        this.url,
        param,
        function (result) {
          let time
          let statistics = []

          const times = result.times

          if (param.type === 'salesTp') {
            let key = '오전'
            for (let i = 0; i < times.length; i++) {
              const time = times[i]
              const types = time.types
              let cash
              let card
              let point
              let easy
              let online
              let etc
              let sum = 0

              types.forEach(function (type) {
                let tp = type.type
                if (tp === 'CASH') {
                  cash = type.amount
                }
                if (tp === 'CARD') {
                  card = type.amount
                }
                if (tp === 'POINT') {
                  point = type.amount
                }
                if (tp === 'EASY') {
                  easy = type.amount
                }
                if (tp === 'ONLINE') {
                  online = type.amount
                }
                if (tp === 'ETC') {
                  etc = type.amount
                }
                if (tp !== 'POINT') {
                  sum += type.amount
                }
                // });
              })

              if (time.date.includes('오전')) {
                key = '오전'
              } else if (time.date.includes('오후')) {
                key = '오후'
              }

              const regex = /[^0-9]/g
              let date = time.date.replace(regex, '')
              let number = parseInt(date)
              date = this.dateFormatter2(number, key)
              statistics.push({
                date: date,
                cash: cash,
                card: card,
                point: point,
                easy: easy,
                online: online,
                etc: etc,
                sum: sum,
              })
            }
          }

          if (param.type === 'orderTp') {
            let key = '오전'
            for (let i = 0; i < times.length; i++) {
              const time = times[i]
              const types = time.types

              let pos
              let kiosk
              let table
              let telephone
              let deliveryApp
              let partner
              let mobileTable
              let etc
              let sum = 0

              types.forEach(function (type) {
                let tp = type.type
                if (tp === 'POS_ORDER') {
                  pos = type.amount
                }
                if (tp === 'KIOSK_ORDER') {
                  kiosk = type.amount
                }
                if (tp === 'TABLE_ORDER') {
                  table = type.amount
                }
                if (tp === 'TELEPHONE_ORDER') {
                  telephone = type.amount
                }
                if (tp === 'DELIVERY_APP_ORDER') {
                  deliveryApp = type.amount
                }
                if (tp === 'PARTNER_ORDER') {
                  partner = type.amount
                }
                if (tp === 'MOBILE_TABLE_ORDER') {
                  mobileTable = type.amount
                }
                if (tp === 'ETC_ORDER') {
                  etc = type.amount
                }
                sum += type.amount
              })

              if (time.date.includes('오전')) {
                key = '오전'
              } else if (time.date.includes('오후')) {
                key = '오후'
              }

              const regex = /[^0-9]/g

              let date = time.date.replace(regex, '')
              let number = parseInt(date)
              date = this.dateFormatter2(number, key)
              statistics.push({
                date: date,
                pos: pos,
                kiosk: kiosk,
                table: table,
                telephone: telephone,
                deliveryApp: deliveryApp,
                partner: partner,
                mobileTable: mobileTable,
                etc: etc,
                sum: sum,
              })
            }
          }

          this.tableData = statistics
        }.bind(this),
        false
      )
    },
    dateFormatter: function (number) {
      let singleDigitCorrection = ''
      if (number < 10) {
        singleDigitCorrection = '0'
      }

      let time = number
      let division = '오전'
      if (number === 12) {
        time = 12
        division = '오후'
      } else if (number > 12) {
        time = number % 12
        division = '오후'
      }

      return division + ' ' + singleDigitCorrection + time + '시'
    },
    dateFormatter2: function (number, division) {
      let singleDigitCorrection = ''
      if (number < 10) {
        singleDigitCorrection = '0'
      }

      let time = number
      // let division = '오전';
      if (number === 12) {
        time = 12
        // division = '오후';
      } else if (number > 12) {
        time = number % 12
        // division = '오후';
      }

      return division + ' ' + singleDigitCorrection + time + '시'
    },
  },
}
</script>

<style scoped>
.area-date {
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
}

@media (max-width: 1440px) {
  .area-date {
    display: block;
    margin-left: 0;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>
